import React from "react";
// import axios from "axios";
import moment from "moment";
import HtmlDiv from "sites-common/components/HtmlDiv";
import Marquee from "react-fast-marquee";
// import getMandatoryEnv from "../../../../../sites-common/utils/getMandatoryEnv";
import Loader from "react-loader-spinner";
import Bookappointment from "../forms/Bookappointment";
import VerticalImpBlock from "./VerticalImpBlock";
import background from "../../../assets/images/kmc-images/banner.png";
// import eventsBanner from "../../../assets/images/kmc-images/Group-7271.png";
import useCommonData from "../customeSection/useCommonData";

const BannerBlock = () => {
  const {
    bannerRes,
    loading,
    specialvisits,
    getothers,
    checkBothExpired,
    imp1,
    dateFormat,
  } = useCommonData();
  const item = bannerRes?.data[0];
  const fromStart = moment(item?.valid_from, dateFormat).format();
  const dateEnd = moment(item?.valid_to, dateFormat).format();
  const todayDate = moment(new Date(), dateFormat).startOf("day").format();

  return (
    <section>
      {loading === false ? (
        <div sx={{ display: "flex", maxWidth: "160px", margin: "4rem auto" }}>
          <Loader
            type="Oval"
            color="#203b80"
            width={30}
            height={25}
            className="kmc-loader-banner"
          />
        </div>
      ) : (
        <>
          {todayDate >= fromStart && todayDate <= dateEnd ? (
            <div className="banner_main_div">
              <div className="container-fluid">
                <div className="row">
                  <div
                    className={
                      imp1.includes("true") || specialvisits?.length > 0
                        ? "col-lg-8 col-md-12 col-pd banner_img"
                        : "col-md-12 banner_w100"
                    }
                    style={{ backgroundImage: `url(${item.image})` }}
                  >
                    <div className="banner_title">
                      <h1>{item.title ? item.title : null}</h1>
                      <h3>{item.description ? item.description : null}</h3>
                      <h4>{item.date ? item.date : null}</h4>
                      <h5>
                        {" "}
                        <span className="item_description">
                          {item.time_description ? item.time_description : null}
                        </span>
                        <span className="time_hours">
                          {item.time ? item.time : null}
                        </span>
                      </h5>
                    </div>
                    <Bookappointment />
                    <div>
                      {getothers?.map((scroll) => {
                        const httpHtml = (content) => {
                          const reg =
                            /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
                          return content.replace(
                            reg,
                            " <a href='$1$2' target='_blank' rel='noreferrer'> &nbsp $1$2 &nbsp</a> "
                          );
                        };
                        return (
                          <>
                            {scroll.type === "scroller" ? (
                              <>
                                <div className="news">News</div>
                                <div
                                  className={
                                    imp1.includes("true") ||
                                    specialvisits?.length > 0
                                      ? "Scrollar_text"
                                      : "w100"
                                  }
                                >
                                  <Marquee gradient={false} speed={50}>
                                    <HtmlDiv
                                      htmlString={httpHtml(scroll.message)}
                                    />
                                  </Marquee>
                                </div>
                              </>
                            ) : null}
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className=" col-lg-4 col-md-12 visitors-col-pd">
                    <div className="upcoming-spc">
                      <VerticalImpBlock
                        visits={specialvisits}
                        Important={getothers}
                        imp1={imp1}
                        checkBothExpired={checkBothExpired}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="banner_main_div">
              <div className="container-fluid">
                <div className="row">
                  <div
                    className={
                      imp1.includes("true") || specialvisits?.length > 0
                        ? "col-lg-8 col-md-12 col-pd banner_img_default"
                        : "col-md-12 banner_img2"
                    }
                    style={{ backgroundImage: `url(${background})` }}
                  >
                    <div className="defult_banner_title">
                      {/* <h3>Inspiring better health</h3> */}
                      <h1>THE GREATEST WEALTH IS HEALTH</h1>
                      {/* <h4>to life for the whole family</h4> */}
                    </div>
                    <Bookappointment />
                    <div>
                      {getothers?.map((scroll) => {
                        const httpHtml = (content) => {
                          const reg =
                            /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
                          return content.replace(
                            reg,
                            " <a href='$1$2' target='_blank' rel='noreferrer'> &nbsp $1$2 &nbsp</a> "
                          );
                        };
                        return (
                          <>
                            {scroll.type === "scroller" ? (
                              <>
                                <div className="news">News</div>
                                <div
                                  className={
                                    imp1.includes("true") ||
                                    specialvisits?.length > 0
                                      ? "Scrollar_text"
                                      : "w100"
                                  }
                                >
                                  <Marquee gradient={false} speed={50}>
                                    <HtmlDiv
                                      htmlString={httpHtml(scroll.message)}
                                    />
                                  </Marquee>
                                </div>
                              </>
                            ) : null}
                            ;
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 visitors-col-pd">
                    <div className="upcoming-spc">
                      <VerticalImpBlock
                        visits={specialvisits}
                        Important={getothers}
                        imp1={imp1}
                        checkBothExpired={checkBothExpired}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {bannerRes?.message === "No data Found..!" ? (
        <div className="banner_main_div">
          <div className="container-fluid">
            <div className="row">
              <div
                className={
                  imp1.includes("true") || specialvisits?.length > 0
                    ? "col-lg-8 col-md-12 col-pd banner_img_default"
                    : "col-md-12 banner_img2"
                }
                style={{ backgroundImage: `url(${background})` }}
              >
                <div className="defult_banner_title">
                  {/* <h3>Inspiring better health</h3> */}
                  <h1>THE GREATEST WEALTH IS HEALTH</h1>
                  {/* <h4>to life for the whole family</h4> */}
                </div>
                <Bookappointment />
                <div>
                  {getothers?.map((scroll) => {
                    const httpHtml = (content) => {
                      const reg =
                        /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
                      return content.replace(
                        reg,
                        " <a href='$1$2' target='_blank' rel='noreferrer'> &nbsp $1$2 &nbsp</a> "
                      );
                    };
                    return (
                      <>
                        {scroll.type === "scroller" ? (
                          <>
                            <div className="news">News</div>
                            <div
                              className={
                                imp1.includes("true") ||
                                specialvisits?.length > 0
                                  ? "Scrollar_text"
                                  : "w100"
                              }
                            >
                              <Marquee gradient={false} speed={50}>
                                <HtmlDiv
                                  htmlString={httpHtml(scroll.message)}
                                />
                              </Marquee>
                            </div>
                          </>
                        ) : null}
                        ;
                      </>
                    );
                  })}
                </div>
              </div>
              <div className="col-lg-4 col-md-12 visitors-col-pd">
                <div className="upcoming-spc">
                  <VerticalImpBlock
                    visits={specialvisits}
                    Important={getothers}
                    imp1={imp1}
                    checkBothExpired={checkBothExpired}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default BannerBlock;
